// BOX AJAX
export const FETCH_BOX_LODING = "FETCH_BOX_LODING";
export const FETCH_BOX_OPEN_SUCCESS = "FETCH_BOX_OPEN_SUCCESS";
export const FETCH_BOX_NOT_OPEN_SUCCESS = "FETCH_BOX_NOT_OPEN_SUCCESS";
export const FETCH_BOX_FAIL = "FETCH_BOX_FAIL";

// UpdateStatus(Box)
export const UPDATE_DONATIONTYPE = "UPDATE_DONATIONTYPE";
export const UPDATE_TAB = "UPDATE_TAB";



// WEBPACK FOOTER //
// ./src/type/ActionTypes.js